module.exports = __webpack_public_path__ + "static/media/phone-ico1.98da0ec7.svg";